/**
 * Infere se o texto digitado no PDV parece código (barras/SKU) ou nome para o cadastro rápido.
 */
export function inferRegisterPrefillFromSearch(raw: string): {
  initialCode: string;
  initialName: string;
} {
  const t = raw.trim();
  if (!t) {
    return { initialCode: "", initialName: "" };
  }
  const digitsOnly = /^\d{8,}$/.test(t);
  const digitsCompressed = t.replace(/\D/g, "");
  const mostlyBarcode = /^[\d\s-]+$/.test(t) && digitsCompressed.length >= 8;
  if (digitsOnly || mostlyBarcode) {
    return { initialCode: digitsCompressed || t.replace(/\s/g, ""), initialName: "" };
  }
  const skuLike =
    /^[A-Z0-9][A-Z0-9._-]*$/i.test(t) && t.length >= 4 && t.length <= 40 && !/\s/.test(t);
  if (skuLike) {
    return { initialCode: t, initialName: "" };
  }
  return { initialCode: "", initialName: t };
}
